import React, { useMemo } from "react";

import VerticalSpacing from "@cayuse/shared-react.components.vertical-spacing";

import CollapsibleSection from "containers/Form/SimplifiedBuilder/Internal/CollapsibleSection";
import PaletteItem from "containers/Form/SimplifiedBuilder/Internal/PaletteItem";
import { useSFBComponents } from "hooks";

import { createNewElementByType, getPaletteItemsByGroup, GROUPS } from "./utils";

function SimplifiedFormBuilderPalette ({ onPaletteDropEnd }) {
	const components = useSFBComponents();
	const paletteItemsByGroup = useMemo(
		() => getPaletteItemsByGroup(components),
		[ components ]
	);

	return (
		<div>
			{GROUPS.map((group, groupIndex) => (
				<VerticalSpacing key={`group-${groupIndex}`}>
					<CollapsibleSection title={group.name}>
						{(paletteItemsByGroup[group.id] || []).map((item, index) => (
							<PaletteItem
								key={`item-${index}`}
								itemType={group.itemType}
								text={item.name}
								elementCreator={() => createNewElementByType(components, item.type, group.itemType)}
								onPaletteDropEnd={onPaletteDropEnd}
							>
								{item.name}
							</PaletteItem>
						))}
					</CollapsibleSection>
				</VerticalSpacing>
			))}
		</div>
	);
}

SimplifiedFormBuilderPalette.createNewElementByType = createNewElementByType;

export default SimplifiedFormBuilderPalette;
